import Rails from 'rails-ujs';

window.addEventListener('load', () => {
  ['name', 'model_number', 'caption', 'user_name'].forEach((attr_name) => {
    const input = Rails.$(`#item_${attr_name}`)[0] || Rails.$(`#${attr_name}`)[0];
    if ( !input ) { return; }
    input.addEventListener('input', (e) => {
      const textLength = Rails.$(`#item_${attr_name}_length`)[0] ||  Rails.$(`#${attr_name}_length`)[0];
      textLength.innerText = e.target.value.length;
    });
  });
});
